import { render, staticRenderFns } from "./ReviewableShare.vue?vue&type=template&id=35b5dab7&scoped=true"
import script from "./ReviewableShare.vue?vue&type=script&lang=js"
export * from "./ReviewableShare.vue?vue&type=script&lang=js"
import style0 from "./ReviewableShare.vue?vue&type=style&index=0&id=35b5dab7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b5dab7",
  null
  
)

export default component.exports